export default Object.freeze({
  adminAuthUrl: `${process.env.API_URL_FOR_FRONT}/api/v1/admin_auth`,
  adminUrl: `${process.env.API_URL_FOR_FRONT}/api/v1/admin`,
  partnerAuthUrl: `${process.env.API_URL_FOR_FRONT}/api/v1/partner_auth`,
  shoppingApiUrl: `${process.env.API_URL_FOR_FRONT}/api/v1/shopping`,
  shoppingFrontUrl: `${process.env.FRONT_URL}/shopping/shopping_orders`,
  IMAGE_SKIP_VALUE: 'N/A',
  isDevelop: () => process.env.RAILS_ENV === 'development'
});
